import { render } from "./MeasureTypeChooser.vue?vue&type=template&id=619d62a6"
import script from "./MeasureTypeChooser.vue?vue&type=script&lang=js"
export * from "./MeasureTypeChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__